const MINUTES_BEFORE_EXPIRATION = 5

export const checkTokenAndUpdate = (expiration, refetch) => {
  const currentTime = Date.now()
  const expirationTime = Date.parse(expiration)

  const timeUntilExpiration = expirationTime - currentTime
  const timeToUpdate = MINUTES_BEFORE_EXPIRATION * 60 * 1000

  if (timeUntilExpiration <= timeToUpdate) {
    refetch()
  }
}
